<template>
	<div class="chart-unit-tips">
		<span>{{ getCurrUnitTips }}</span>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['getCurrUnitTips'])
	}
};
</script>

<style lang="less" scoped>
.chart-unit-tips {
	display: inline-block;
	height: 18px;
	line-height: 18px;
	padding: 0 8px;
	background: #f2f3f5;
	font-size: 0;

	span {
		color: #86909c;
		 
		font-size: 10px;
		 
		font-weight: 500;
	}
}
</style>
